export default {
    name: 'adivare-list-item-wrapper',
    props: [
        'rental',
        'index',
    ],
    computed: {
        houseStatuses() {
            return this.$store.state.houseStatuses;
        },
    },
}
